import 'bootstrap/dist/css/bootstrap.min.css';
import './css/Footer.css';
import './css/Fonts.css';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { legalDocs } from '../content';
import logo from './img/inforight_logo_transparent.png';

function Footer() {
  return (
    <footer className="site-footer">
      <Container>
        <Row className="g-4">
          <Col md={4}>
            <div className="footer-brand">
              <img src={logo} alt="InfoRight" width="34" height="34" />
              <span className="footer-brand-name">InfoRight</span>
            </div>
            <p className="footer-blurb">
              Integrating and using information from the separate systems mining companies already
              run.
            </p>
          </Col>
          <Col xs={6} md={2}>
            <p className="footer-heading">Product</p>
            <ul className="footer-links">
              <li>
                <Link to="/products">Products</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/pricing">Pricing</Link>
              </li>
            </ul>
          </Col>
          <Col xs={6} md={2}>
            <p className="footer-heading">Company</p>
            <ul className="footer-links">
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </Col>
          <Col md={4}>
            <p className="footer-heading">Legal</p>
            <ul className="footer-links">
              {legalDocs.map((doc) => (
                <li key={doc.path}>
                  <Link to={doc.path}>{doc.title}</Link>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} InfoRight, Inc.</p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
